import io from "socket.io-client";
import constant from "../../constant";

let socket = null;
const messageListeners = new Set();

const resolveSocketUrl = () => {
  const raw =
    process.env.REACT_APP_SOCKET_URL ||
    process.env.REACT_APP_BASE_URL ||
    constant.BACKEDN_BASE_URL;
  return String(raw || "").replace(/\/$/, "");
};

const readToken = () => {
  const value = localStorage.getItem("token");
  if (!value || value === "undefined" || value === "null") return null;
  return value;
};

const notifyListeners = (message) => {
  messageListeners.forEach((callback) => {
    try {
      callback(message);
    } catch (error) {
      console.error("[SI_SOCKET] listener error:", error);
    }
  });
};

export const ensureSocketConnected = () => {
  const token = readToken();
  const url = resolveSocketUrl();

  if (!token || !url) {
    return null;
  }

  if (socket?.connected) {
    return socket;
  }

  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }

  socket = io(url, {
    auth: { token },
    transports: ["websocket", "polling"],
    reconnectionAttempts: 5,
    reconnectionDelay: 2000,
    reconnectionDelayMax: 10000,
  });

  socket.on("connect", () => {
    console.log("[SI_SOCKET] connected");
  });

  socket.on("message", notifyListeners);
  socket.on("newMessage", notifyListeners);

  socket.on("connect_error", (error) => {
    console.warn("[SI_SOCKET] connect_error:", error?.message || error);
  });

  socket.on("disconnect", (reason) => {
    console.log("[SI_SOCKET] disconnected:", reason);
  });

  return socket;
};

/** Subscribe to socket messages. Returns an unsubscribe function. */
export const subscribeToSocketMessages = (callback) => {
  if (typeof callback === "function") {
    messageListeners.add(callback);
  }
  ensureSocketConnected();
  return () => {
    messageListeners.delete(callback);
  };
};

/** @deprecated Prefer subscribeToSocketMessages — kept for existing callers. */
export const initializeSocket = (callback) => subscribeToSocketMessages(callback);

export const getSocket = () => socket;

export const disconnectSocket = () => {
  messageListeners.clear();
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
};
